import 'css-chunksrc/client/scenes/optimizedGantt/header/viewsSelector/styles.scss';export default {
  "viewsSelector": "_viewsSelector_1jqgz_1",
  "input": "_input_1jqgz_6",
  "icon": "_icon_1jqgz_23",
  "list": "_list_1jqgz_29",
  "item": "_item_1jqgz_42",
  "open": "_open_1jqgz_53"
};